// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "aa819e67c4499b50732f8d95e8852f83" + ".js";
};